<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="formattedFiles"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Prescreen Files</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <state-paddings />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.actions="{ item }">
      <v-icon
        v-if="hasPermission('view prescreen::file')"
        :id="item"
        class="mr-10"
        @click="redirectFileDetailsPage(item)"
      >
        mdi-format-list-bulleted-square
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-format-list-bulleted-square"
        :text-button="true"
        permission="view prescreen::file"
        :x-small="false"
        button-class="mr-10"
      />
    </template>
  </v-data-table-server>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';
import { formatDateTime } from '@/services/HelperService';
import DisabledForLackOfRoleBtn from '../../../DisabledForLackOfRoleBtn.vue';
import StatePaddings from './StatePaddings.vue';

export default {
  components: {
    StatePaddings,
    DisabledForLackOfRoleBtn,
  },
  mixins: [
    dataTableMixin,
  ],
  data: () => ({
    headers: [
      { title: 'Name', value: 'name' },
      { title: 'Type', value: 'type' },
      { title: 'Import Status', value: 'status' },
      { title: 'Sub Status', value: 'sub_status' },
      { title: 'Created At', value: 'created_at' },
      { title: 'Last Updated At', value: 'updated_at' },
      {
        title: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'start',
        width: 183,
      },
    ],
  }),

  computed: {
    formattedFiles() {
      return (this.items || []).map((item) => ({
        ...item,
        created_at: formatDateTime(item.created_at),
        updated_at: formatDateTime(item.updated_at),
        type: item.type.toUpperCase(),
        status: item.status.toUpperCase(),
        sub_status: item.sub_status ? item.sub_status.toUpperCase() : null,
      }));
    },
  },
  methods: {
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/prescreen/files', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
    redirectFileDetailsPage(item) {
      this.$router.push({ name: 'prescreen-file', params: { id: item.id } });
    },
  },
};
</script>
